import React from 'react';
import WellnessInfowindow from "./WellnessInfowindow";
import MessageModal from "../common/MessageModal";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import BackdropWrapper from '../common/BackdropWrapper';

const PROGRAM_STATUS = { VIEWINBOX: "VIEW INBOX", GETSTARTED: "GET STARTED", COMPLETED: "COMPLETED" };

class WellnessGoals extends React.Component {
    constructor(props) {
        super(props);
        this.state = { openModal: false, openGetstartedModal: false};

    }

    toggleModal = () => {
        this.setState({ openModal: !this.state.openModal });
    }
    //getProgramStatus = (goalProgramId) => {
    //    let wellnessDCJList = null;
    //    let programFoundInList = null;
    //    const { bffDashboardData, currentUser } = this.props;
    //    if (currentUser && currentUser.epi && bffDashboardData && bffDashboardData.data && bffDashboardData.data.dcjStatus && bffDashboardData.data.dcjStatus.wellnessDCJList) {
    //        wellnessDCJList = bffDashboardData.data.dcjStatus.wellnessDCJList;
    //        if (wellnessDCJList && wellnessDCJList.length > 0)
    //            programFoundInList = wellnessDCJList.find(el => el.wellness_journey_id === goalProgramId && el.patient_id === currentUser.epi);
    //    }
    //    if (programFoundInList) {
    //        const { complete, terminated } = programFoundInList;
    //        return complete || terminated ? { status: PROGRAM_STATUS.GETSTARTED, showInbox: false, showCompleted: true } : { status: PROGRAM_STATUS.VIEWINBOX, showInbox: true, showCompleted: false };
    //    }
    //    else
    //        return { status: PROGRAM_STATUS.GETSTARTED, showInbox: false, showCompleted: false };
    //}
    //onDcjSelfOrder = (goalProgramId, goalName) => {
    //    this.setState({ tryAgain: false, openGetstartedModal: true, });
    //    const { serverData, hasMyChartLogin } = this.props
    //    if (serverData && serverData.enableDCJSelfEnrollForWellness && hasMyChartLogin) {
    //        if (goalProgramId) {
    //            const { myChartId, dcjSelfOrder, userToken } = this.props;
    //            dcjSelfOrder(userToken, myChartId, goalProgramId);
    //            logUI("MBHWeb.UI.WellnessReport." + goalName.trim() + "GetStartedCTA", new Date(), Tools.getURLPath());
    //        }
    //    }
    //    else {
    //        logUI("MBHWeb.UI.WellnessReport.GetStarted.NoMedicalRecord.Clicked", new Date(), Tools.getURLPath());
    //    }
    //}

    //loadInbox = (goalName) => {
    //    logUI("MBHWeb.UI.WellnessReport.ViewInbox." + goalName.trim() + "CTA", new Date(), Tools.getURLPath());
    //    this.props.history.push("/wellbeinginbox");
    //}

    toggleGetstartedModal = () => {
        this.setState({ openGetstartedModal: !this.state.openGetstartedModal });
        //const { serverData, hasMyChartLogin } = this.props
        //if (serverData && serverData.enableDCJSelfEnrollForWellness && hasMyChartLogin) {
        //    logUI("MBHWeb.UI.WellnessReport.DcjSelfOrderModal.Okay.Clicked", new Date(), Tools.getURLPath());
        //} else {
            logUI("MBHWeb.UI.WellnessReport.NoMedicalRecordModal.Okay.Clicked", new Date(), Tools.getURLPath());
        //}

    };

    tryAgain = (e) => {
        e.preventDefault();
        this.setState({ tryAgain: true });
        logUI("MBHWeb.UI.WellnessReport.onTryAgain", new Date(), Tools.getURLPath());
    }

    render() {
        const { openModal, openGetstartedModal } = this.state;
        const { report, hasMyChartLogin, showDCJSelfEnrollToolTip, serverData, currentYear, updateDCJSelfEnrollToolTipPreference, isWellnessReport, isWellBeingDashboard } = this.props;
        let goals = [];
        let hasGoals = false;
        let btnStyle = isWellnessReport ? 'btn text-btn' : "btn btn-primary";
        // Get Current year data to show current year score 
        let currentYearReport = report && report.length > 0 && report.filter(item => item.year === currentYear)[0];
        if (currentYearReport && currentYearReport.results && currentYearReport.results.length > 0) {
            goals = currentYearReport.results.map((r, i) => {
                //const { status, showInbox, showCompleted } = this.getProgramStatus(r.goalProgramId);
                hasGoals = r.goals && r.goals.length > 0 && r.goals[0] !== null;

                return (
                    <React.Fragment key={"goals_" + i}>
                        {
                            !hasGoals ?
                                <li key={"goal_" + i} className={`${r.name === 'Overall' ? 'hidden' : ''}`}>
                                    <a href={r.goalLink} target="_blank"><b>{r.name}</b></a>
                                    <div>No goals selected for this wellness category</div>
                                </li>
                                :
                                (hasGoals === true/* || (serverData && serverData.enableDCJSelfEnrollForWellness)*/) &&
                                <li key={"goal_" + i} className={`${r.name === 'Overall' ? 'hidden' : ''}`}>
                                    <a href={r.goalLink} target="_blank"><b>{r.name}</b></a>
                                    <div className="row">
                                        {r.goals.map((g, gi) =>
                                            <div key={"goal_childnode_" + gi} className="col-8 col-md-12">
                                                <div >{g}</div>
                                            </div>)
                                        }
                                        {/*<div className="col-4 col-md-12">
                                            {serverData && serverData.enableDCJSelfEnrollForWellness && hasMyChartLogin && r.goalProgramId
                                                ? showInbox
                                                    ? <button type="button" className={btnStyle} onClick={() => this.loadInbox(r.name)}>{status}</button>
                                                    : <div>
                                                        {showCompleted && <div className="success-msg" style={{ fontSize: "14px", lineHeight: "1.5em" }}>You have completed this journey. Click Get Started to enroll again.</div>}
                                                        <button type="button" className={btnStyle} onClick={(e) => this.onDcjSelfOrder(r.goalProgramId, r.name)}>{status}</button>
                                                    </div>
                                                :
                                                <button type="button" className={btnStyle} onClick={() => this.onDcjSelfOrder(r.goalProgramId, r.name)}>Get Started</button>}
                                        </div>*/}
                                    </div>
                                    <div className="row">
                                        <div className="col-12 d-block d-md-none"></div>
                                    </div>
                                </li>
                        }
                    </React.Fragment>
                );
            });
        }
        let modalBody = /*serverData && serverData.enableDCJSelfEnrollForWellness && hasMyChartLogin
            ? (
                <div className="journey-waiting-modal-content">
                    <h3 className="heading"><span className="svg-trophy" />Just a sec!</h3>
                    <p>
                        We're getting your care journey ready. Once it's ready, you'll receive an email or text notification to view messages in your inbox.
                    </p>
                    <p>
                        You can also get to your inbox from the MyBSWH dashboard.
                    </p>
                </div>
            )
            : */<p> This feature is currently being tested with BSWH Employee Core Champions.If you are seeing this message, you don't have required medical record linkage. More information will be available soon.</p>
        let modalFooterButtons = [{ label: "OKAY", handleClick: () => this.toggleGetstartedModal() }]
        let modalClassName = "wellness-getStarted-modal"
        const topThreeGoals = goals.slice(0, 3);
        const restOfGoals = goals.filter(goal => !topThreeGoals.includes(goal));
        const wellnessReportContainerClass = " row well-being__goals";
        return (<React.Fragment>
            <BackdropWrapper onClickBackdrop={updateDCJSelfEnrollToolTipPreference}
                toolTipInfo="We've added Well-Being Journeys for you to take the first steps towards achieving your well-being goals."
                okBtnText="OKAY, GOT IT!" showTooltip={false/*showDCJSelfEnrollToolTip && isWellnessReport && serverData.enableDCJSelfEnrollForWellness*/}
                wrapperClass={`goals-container well-being-goals${isWellnessReport ? wellnessReportContainerClass : isWellBeingDashboard ? " wellness-goal-tile" : ''}`}
            >
                <div className={`${isWellnessReport ? "col-12 maxWidth-content" : ""}`}>
                    <div className={`list-row${isWellnessReport ? " row" : ""}`}>
                        <div className="col-12">
                            <div className="svg-trophy" />
                            <div className="well-being-goals__header">{false/*serverData.enableDCJSelfEnrollForWellness*/ ? 'Well-Being Journeys & Resources' : 'Well-Being Goals & Links'}</div>
                            {/*{serverData.enableDCJSelfEnrollForWellness && hasMyChartLogin && <span className="icon-question" onClick={this.toggleModal} />}*/}
                            <ul className="goals-ui-separator">
                                {topThreeGoals && topThreeGoals.length > 0 && <div className="goal-heading">My Top 3</div>}
                                {topThreeGoals}
                                {restOfGoals && restOfGoals.length > 0 && <div className="goal-heading">More</div>}
                                {restOfGoals}
                            </ul>
                            <div className="row view-resources">
                                {!isWellnessReport &&
                                    <div className="col-7 col-md-12 resources-text">Want to learn more about each category?</div>
                                }
                                <div className="col-5 col-md-12">
                                    <a className="link" href="https://www.bswhealth.com/wellness-resources/" target="_blank">VIEW RESOURCES</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </BackdropWrapper>
            <WellnessInfowindow showInfo={openModal} toggle={this.toggleModal} technicalHelpDeskNumber={serverData.technicalHelpDeskNumber} technicalHelpDeskHours={serverData.technicalHelpDeskHours} />
            <MessageModal showInfo={openGetstartedModal} toggle={this.toggleGetstartedModal} modalBody={modalBody} modalFooterButtons={modalFooterButtons} className={modalClassName} />
        </React.Fragment>);
    }
}

const mapStateToProps = (state) => {
    return {
        report: state.thrive.report,
        serverData: state.session.serverData,
        showDCJSelfEnrollToolTip: state.session.showDCJSelfEnrollToolTip,
        myChartId: state.domain.mc,
        hasMyChartLogin: state.domain.hm,
        bffDashboardData: state.dashboard.bffDashboardData,
        currentUser: state.domain.cu,
        userToken: state.domain.t
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dcjSelfOrder: (token, myChartId, goalProgramId) => {
            //dispatch({ type: types.DCJ_SELF_ORDER, token, myChartId, goalProgramId });
        },
        updateDCJSelfEnrollToolTipPreference: () => {
            //dispatch({ type: types.UPDATE_DCJ_SELF_ENROLL_TOOLTIP_PREFERENCE });
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WellnessGoals));